import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  shape: {
    fill: '#7df3e1',
  },
  wordmark: {
    fill: '#7df3e1',
    fontFamily: '"GT Ultra Median", Georgia, serif',
    fontSize: 80,
    letterSpacing: 1,
  },
});

const HRow = ({ y, className }: { y: number; className: string }) => (
  <g transform={`translate(0 ${y})`}>
    <rect className={className} x="0" y="0" width="20" height="54" rx="3" />
    <rect className={className} x="44" y="0" width="20" height="54" rx="3" />
    <rect className={className} x="20" y="20" width="24" height="14" rx="3" />
  </g>
);

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 520 186"
      role="img"
      aria-label="Howden stacked H logo"
    >
      <HRow y={0} className={classes.shape} />
      <HRow y={66} className={classes.shape} />
      <HRow y={132} className={classes.shape} />
      <text className={classes.wordmark} x="92" y="130">
        Howden
      </text>
    </svg>
  );
};
